module.exports = __webpack_public_path__ + "img/ziyouwangguo3.9e419a04.jpg";